import { render, staticRenderFns } from "./parkingApiTestList.vue?vue&type=template&id=31008ef4&scoped=true"
import script from "./parkingApiTestList.vue?vue&type=script&lang=js"
export * from "./parkingApiTestList.vue?vue&type=script&lang=js"
import style0 from "./parkingApiTestList.vue?vue&type=style&index=0&id=31008ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31008ef4",
  null
  
)

export default component.exports